import React, { useEffect, useState } from 'react';
import styles from '../../styles/components/sections/TrustedBySection.module.css';
import { isSafari } from '../../utils/helpers/utils';
import { useDarkMode } from '../../utils/hooks/useDarkMode';
import { OptimizedImage } from '../common';

/**
 * A reusable component that displays trusted by logos with scrolling animation
 *
 * @param {Object} props
 * @param {Object} props.data - The trusted by data from Strapi
 * @param {String} props.data.title - Section title
 * @param {Array} props.data.trusted_customers - Array of customer logo objects
 */
const TrustedBySection = ({ data }) => {
  // const { isDarkMode } = useDarkMode();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isClient, setIsClient] = useState(false);



  // Set client-side flag
  useEffect(() => {
      setIsClient(true);
  }, []);

  // Detect system dark mode preference
  useEffect(() => {
      if (!isClient) return;

      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      setIsDarkMode(mediaQuery.matches);

      const handleChange = e => {
          setIsDarkMode(e.matches);
          updateTheme(e.matches ? 'dark' : 'light');
      };

      mediaQuery.addEventListener('change', handleChange);

      // Check for saved theme preference
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme) {
          setIsDarkMode(savedTheme === 'dark');
          updateTheme(savedTheme);
      } else {
          // Set initial theme based on system preference
          updateTheme(mediaQuery.matches ? 'dark' : 'light');
      }

      return () => mediaQuery.removeEventListener('change', handleChange);
  }, [isClient]);

  // Detect mobile device
  useEffect(() => {
      if (!isClient) return;

      const checkMobile = () => {
          setIsMobile(window.innerWidth <= 768);
      };

      checkMobile();
      window.addEventListener('resize', checkMobile);

      return () => window.removeEventListener('resize', checkMobile);
  }, [isClient]);

  // Update theme on document
  const updateTheme = theme => {
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('theme', theme);
  };
  
  if (!data) return null;

  // Filter logos that have valid URLs
  const validLogos = data?.trusted_customers?.filter(item => item?.logo?.url) || [];

  // Duplicate logos for seamless scrolling
  const duplicatedLogos = [...validLogos, ...validLogos,...validLogos, ...validLogos,...validLogos, ...validLogos,...validLogos,...validLogos, ...validLogos];

  return (
    <section className={`py-6 ${isDarkMode ? styles['dark-section'] : ''}`} style={{ background: isDarkMode ? 'var(--bg-primary)' : '#fff' }}>
      <div className="tw-container">
        <div className="row justify-content-center">
          <p className={`text-center ${styles['tb-heading']} ${isDarkMode ? styles['dark-heading'] : ''}`}>{data?.title}</p>
          <div className="row pt-5 justify-content-md-center">
            <div className={styles['scroll-container']}>
              <div className={styles['scroll-content']} >
                {duplicatedLogos.map((item, index) => (
                  <div key={index} className={styles['scroll-item']}>
                     <div className={`${styles['tb-card']} ${isDarkMode ? styles['dark-card'] : ''}`}>
                      <OptimizedImage
                        src={item.logo.url}
                        alt={item.logo.alternativeText || `Trusted partner ${index + 1}`}
                        className={styles['img-settings']}
                        width={84}
                        height={80}
                        style={{ objectFit: 'contain', width: '100%' }}
                        priority={false}
                        loading="lazy"
                        quality={40}
                        sizes="100px"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBySection;
